<template>
  <Editor :id="id" :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)"
    :tinymce-script-src="`${base}tinymce/tinymce.min.js`" :init="options" :disabled="disabled" />
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

// Runtime files and the pinned Traditional Chinese language pack are copied by vue.config.js.
export default {
  name: 'LocalRichTextEditor',
  components: { Editor },
  props: { modelValue: { type: String, default: '' }, id: String, init: { type: Object, default: () => ({}) }, disabled: Boolean },
  emits: ['update:modelValue'],
  computed: {
    base() { return process.env.BASE_URL || '/'; },
    options() {
      return {
        ...this.init,
        license_key: 'gpl',
        base_url: `${this.base}tinymce`,
        suffix: '.min',
        language: 'zh_TW',
        language_url: `${this.base}tinymce/langs/zh_TW.js`,
        // Only bundled community plugins; no remote cloud or premium dependencies.
        plugins: 'autolink code fullscreen image link lists preview searchreplace table visualblocks wordcount',
        menubar: 'edit view insert format tools table',
        toolbar: 'undo redo | blocks | bold italic underline | alignleft aligncenter alignright | bullist numlist | link image table | code fullscreen preview',
        branding: false,
        promotion: false,
        skin: 'oxide-dark',
        content_css: 'dark',
        height: this.init.height || 400,
        allow_script_urls: false,
        invalid_elements: 'script,iframe,object,embed,form,input,button,link,meta',
        extended_valid_elements: '',
        valid_children: '',
        content_style: 'body { font-family: sans-serif; color: #eee; background: #181822; line-height: 1.7; } img { max-width: 100%; height: auto; }'
      };
    }
  }
};
</script>
